import { FormSchema, Lookups } from '@precert/validation';
import React from 'react';
import { FormGroup, Row, Col } from 'reactstrap';

import { DateField } from '../../../../_components/date-field';
import InputField from '../../../../_components/input-field';
import SelectField from '../../../../_components/select-components/select-field';
import type { WizardStepProps } from '../wizard';

import { valuesCodeArray } from './common';

export interface StepVeteranDemographicsProps {
  index: number;
}
const { GenderOptions } = Lookups;
const options = valuesCodeArray(GenderOptions);

export const StepVeteranDemographicsSchema = FormSchema().pick([
  'veteranDob',
  'veteranFirstName',
  'veteranLastName',
  'veteranGender',
]);

export type Gender = 'Male' | 'Female' | 'Unknown';

export interface StepVeteranDemographicsFormData {
  veteranFirstName: string;
  veteranLastName: string;
  veteranDob: Date;
  veteranGender: Gender;
}

export const StepVeteranDemographics = () => {
  return (
    <div>
      <Row>
        <Col sm={12} md={6}>
          <FormGroup>
            <InputField
              name="veteranFirstName"
              label="First Name"
              type="text"
              aria-label="First Name"
            />
          </FormGroup>
        </Col>
        <Col sm={12} md={6}>
          <FormGroup>
            <InputField
              name="veteranLastName"
              label="Last Name"
              type="text"
              aria-label="Last Name"
              required
            />
          </FormGroup>
        </Col>
        <Col sm={12} md={6}>
          <FormGroup>
            <DateField
              name="veteranDob"
              label="Date of Birth"
              required
              maxDate={new Date()}
            />
          </FormGroup>
        </Col>
        <Col sm={12} md={6}>
          <FormGroup>
            <SelectField
              name="veteranGender"
              label="Gender"
              aria-label="Gender"
              required
              options={options}
            />
          </FormGroup>
        </Col>
      </Row>
    </div>
  );
};

export const stepVeteranDemographics: WizardStepProps = {
  title: 'Veteran Demographics',
  schema: StepVeteranDemographicsSchema,
  element: <StepVeteranDemographics />,
  path: 'veteran-demographics',
};
